import React, { ReactNode, useMemo } from 'react';
import classNames from 'classnames';
import { Trans, useTranslation } from 'react-i18next';
import TruncatedText from 'components/TruncatedText';

import './TransWithNda.styles.scss';

export const SHORT_MAX_CHARS = 26;
const LONG_MAX_CHARS = 200;

type TransWithNdaProps = {
  className?: string;
  i18nKey: string;
  envelopeTemplateName?: string;
  values?: Record<string, any>;
  components?: Record<string, ReactNode>;
  maxChars?: number;
  isParagraph?: boolean;
  disableTooltip?: boolean;
};

const TransWithNda: React.FC<TransWithNdaProps> = (props) => {
  const { t } = useTranslation();

  const {
    className,
    i18nKey,
    values,
    components = {},
    envelopeTemplateName,
    maxChars = LONG_MAX_CHARS,
    isParagraph = true,
    disableTooltip,
  } = props;

  const classes = classNames('trans-with-nda', className);

  const trans = useMemo(
    () => (
      <Trans
        i18nKey={i18nKey}
        values={values}
        components={{
          ...components,
          nda: envelopeTemplateName ? (
            <TruncatedText
              text={envelopeTemplateName}
              maxChars={maxChars}
              disableTooltip={disableTooltip}
            />
          ) : (
            t('NDA')
          ),
        }}
      />
    ),
    [
      components,
      envelopeTemplateName,
      i18nKey,
      maxChars,
      disableTooltip,
      values,
      t,
    ],
  );

  if (!i18nKey) return null;

  if (!isParagraph) return <div className={classes}>{trans}</div>;

  return <p className={classes}>{trans}</p>;
};

export default TransWithNda;
